import React, { SetStateAction, useState } from 'react';
import CustomButton from '../CustomButton';
import DragFileMulti from '../DragFileMulti';
import { ReactComponent as FileList } from 'assets/common/fileList.svg'
import { ReactComponent as DelIcon } from 'assets/common/fileDel.svg'
import { toast } from 'react-toastify';
import { formAxios } from 'components/axios';
import { IFileNateon, sendTeamRoom } from 'components/nateon';
import { useGetUser } from 'atom/user';
import { countryCodeToEmoji, getKoreaDateTime } from 'components/function';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    refresh: () => void
    select: IFileNateon
}

const TransportFileUpload = ({ isOpen, setIsOpen, refresh, select }: IConfrimDialog) => {
    const user = useGetUser();
    const [fileArr, setFileArr] = useState<File[]>([]);
    const [once, setOnce] = useState<boolean>(false);

    const cancel = () => {
        setIsOpen(false);
        setFileArr([])
    }

    const upload = () => {
        setOnce(true)
        if (fileArr.length === 0) return toast.error('파일을 업로드 해주세요.')
        const formData = new FormData()
        fileArr.map((item) => (
            formData.append('files', item)
        ))
        formAxios.post(`order/${select.id}/upload`, formData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                refresh();
                setIsOpen(false);
                setFileArr([])
                toast.success('정상적으로 업로드되었습니다.')
                sendTeamRoom('quoteFile', `📦 Pulse On Ship 서류업로드 📄\n
업로드일시: ${getKoreaDateTime()}
유저: ${user.username}
회사이름: ${user.companyInfo.companyNameKr}
운송사/항공사: ${select.carrierName}
경로: ${countryCodeToEmoji(select.originCode.slice(0, 2))} ${select.originCode} | ${select.originAddress} > ${countryCodeToEmoji(select.destinationCode.slice(0, 2))} ${select.destinationCode} | ${select.destinationAddress}`)
            }
            setOnce(false)
        })
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[500px] tablet:w-96">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <p className='text-2xl text-left'>PulseOnShip.com의 내용:</p>
                        <div className='flex flex-col items-start'>
                            <p className='text-lg'>관련 서류를 업로드 하여 주세요.</p>
                            <p className='text-[#9D9EB7]'>*서류는 pdf파일 형태, 15MB까지 업로드 가능합니다</p>
                        </div>

                        <div className='flex flex-col gap-3'>
                            <DragFileMulti
                                onChangeFileMulti={(file) => {
                                    if (!file) return
                                    setFileArr(file)
                                }}
                                description='선택 또는 드래그하여 <br />해당 파일을 등록해 주세요'
                            />

                            <div>
                                {
                                    fileArr.map((item: File, idx: number) => (
                                        <div
                                            className='relative flex items-center gap-3 mb-3 px-6 border border-primary rounded h-10 text-primary text-sm'
                                            key={idx}>
                                            <FileList />
                                            {item.name}

                                            <DelIcon onClick={(e) => {
                                                e.preventDefault()
                                                setFileArr((p) => p.filter((_, i) => i !== idx));
                                            }} className="right-4 absolute cursor-pointer" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className="flex justify-between gap-4">
                            <CustomButton title={'닫기'} onClick={cancel} className='flex-1 hover:!bg-white !border-[#9D9EB7] !h-15 !text-[#9D9EB7]' />
                            <CustomButton
                                disabled={once}
                                title={'업로드'}
                                onClick={upload}
                                className={'flex-1 !h-15 bg-primary'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransportFileUpload;